import { gql } from '@apollo/client/core';

export default gql`
  query OgQuestionnaireNameNew {
    getCustomCategoriesWithSubcategoriesForEntity {
      _id
      name
    }
  }
`;
